// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__emVWT","imageUploader":"EGiftCard_imageUploader__2vjWw"};